import { createResourceStore } from '@next-qr/lib-ui/store';
import { planApi, subscriptionApi } from './api';

export const usePlanStore = createResourceStore(planApi);
export const useSubscriptionStore = createResourceStore(subscriptionApi);
